import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CvReviewLandingComponent } from './cv-review-landing/cv-review-landing.component';
import { CvReviewRoutingModule } from './cv-review-routing.module';
import { MaterialModule } from 'src/app/modules/material/material.module';
import { SharedModule } from 'src/app/modules/shared/shared.module';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { Template1Component } from './templates/template1/template1.component';
import { Template2Component } from './templates/template2/template2.component';
import { Template3Component } from './templates/template3/template3.component';
import { Template4Component } from './templates/template4/template4.component';
import { CvSelectorComponent } from './cv-selector/cv-selector.component';
import { Template5Component } from './templates/template5/template5.component';
import { Template6Component } from './templates/template6/template6.component';
import { Angular4PaystackModule } from 'angular4-paystack';
import { environment } from 'src/environments/environment';
import { CvPreviewComponent } from './cv-preview/cv-preview.component';
import { Template7Component } from './templates/template7/template7.component';
import { Template8Component } from './templates/template8/template8.component';
import { Template9Component } from './templates/template9/template9.component';
import { Template10Component } from './templates/template10/template10.component';
import { Template11Component } from './templates/template11/template11.component';
import { Template12Component } from './templates/template12/template12.component';
@NgModule({
  declarations: [
    CvReviewLandingComponent,
    Template1Component,
    Template2Component,
    Template3Component,
    Template4Component,
    CvSelectorComponent,
    Template5Component,
    Template6Component,
    CvPreviewComponent,
    Template7Component,
    Template8Component,
    Template9Component,
    Template10Component,
    Template11Component,
    Template12Component,
  ],
  imports: [
    CommonModule,
    RouterModule,
    CvReviewRoutingModule,
    MaterialModule,
    SharedModule,
    FormsModule,
    Angular4PaystackModule.forRoot(environment.paystack_key),
  ],
})
export class CvReviewModule {}
